export function isActive(state) {
  return state.isActive;
}
export function isDialogOpen(state) {
  return state.isDialogOpen;
}